// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"8ce3f3ed","703":"d1db722d"}[chunkId] + ".chunk.js";
};